import { ShieldCheck, RotateCcw, ShoppingBag, Truck, HelpCircle, Users, Building2, Briefcase, FileText, Lock, Map, Phone, Mail, MapPin } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useSettings } from '@/modules/settings-api'
import { StaticPage } from './ui/pages/StaticPage'

export function WarrantyPage() {
  return (
    <StaticPage
      title="Chính sách bảo hành"
      subtitle="Bảo hành chính hãng — đổi mới 1-1 trong 30 ngày đầu"
      icon={ShieldCheck}
    >
      <h2>1. Thời gian bảo hành</h2>
      <ul>
        <li>Khung xe: <strong>36 tháng</strong></li>
        <li>Động cơ điện: <strong>24 tháng</strong></li>
        <li>Pin Lithium: <strong>18 tháng</strong></li>
        <li>Bộ điều khiển, sạc: <strong>12 tháng</strong></li>
        <li>Phụ kiện: <strong>6 tháng</strong></li>
      </ul>
      <h2>2. Điều kiện bảo hành</h2>
      <ul>
        <li>Sản phẩm còn trong thời gian bảo hành ghi trên phiếu</li>
        <li>Lỗi do nhà sản xuất, không do va đập, ngập nước, tự ý sửa chữa</li>
        <li>Mang theo phiếu bảo hành và hoá đơn mua hàng</li>
      </ul>
      <h2>3. Cách thức bảo hành</h2>
      <p>Mang xe đến trực tiếp showroom gần nhất hoặc liên hệ hotline để được hướng dẫn gửi về trung tâm bảo hành. Chi phí vận chuyển bảo hành toàn quốc <strong>miễn phí trong năm đầu</strong>.</p>
    </StaticPage>
  )
}

export function ReturnPage() {
  const { data: s } = useSettings()
  return (
    <StaticPage
      title={`Đổi trả ${s.returnPolicyDays ?? 7} ngày`}
      subtitle="Hoàn tiền 100% nếu sản phẩm không đúng mô tả"
      icon={RotateCcw}
    >
      <h2>1. Thời hạn đổi trả</h2>
      <p>Trong vòng <strong>{s.returnPolicyDays ?? 7} ngày</strong> kể từ ngày nhận hàng.</p>
      <h2>2. Điều kiện đổi trả</h2>
      <ul>
        <li>Sản phẩm còn nguyên tem, nhãn, bao bì, phụ kiện đi kèm</li>
        <li>Chưa qua sử dụng, không có dấu hiệu va đập, trầy xước</li>
        <li>Có đầy đủ hoá đơn mua hàng</li>
      </ul>
      <h2>3. Các trường hợp hoàn tiền 100%</h2>
      <ul>
        <li>Sản phẩm giao không đúng mẫu, không đúng mô tả</li>
        <li>Sản phẩm lỗi kỹ thuật ngay khi nhận hàng</li>
        <li>Hãng ngừng sản xuất, không còn hàng thay thế</li>
      </ul>
      <h2>4. Thời gian xử lý</h2>
      <p>Xe Điện Việt xử lý đổi trả trong vòng <strong>24h làm việc</strong> và hoàn tiền trong <strong>3-5 ngày</strong> tới tài khoản của khách.</p>
    </StaticPage>
  )
}

export function BuyingGuidePage() {
  return (
    <StaticPage
      title="Hướng dẫn mua hàng"
      subtitle="4 bước đơn giản để sở hữu xe điện ngay hôm nay"
      icon={ShoppingBag}
    >
      <h2>Bước 1: Chọn sản phẩm</h2>
      <p>Duyệt danh mục <Link to="/danh-muc/xe-may-dien">Xe máy điện</Link>, <Link to="/danh-muc/xe-dap-dien">Xe đạp điện</Link> hoặc <Link to="/danh-muc/phu-kien">Phụ kiện</Link>. Click vào sản phẩm để xem chi tiết.</p>
      <h2>Bước 2: Thêm vào giỏ hàng</h2>
      <p>Bấm <strong>"Thêm vào giỏ"</strong> hoặc <strong>"Mua ngay"</strong> để đi thẳng tới trang thanh toán.</p>
      <h2>Bước 3: Nhập thông tin giao hàng</h2>
      <p>Điền họ tên, số điện thoại, địa chỉ nhận hàng. Có thể nhập mã giảm giá tại đây nếu có.</p>
      <h2>Bước 4: Chọn phương thức thanh toán</h2>
      <ul>
        <li><strong>COD</strong> — Thanh toán khi nhận hàng, kiểm tra trước khi trả tiền</li>
        <li><strong>QR VietQR</strong> — Chuyển khoản qua app ngân hàng, xác nhận tự động</li>
      </ul>
      <p>Sau khi đặt hàng, khách sẽ nhận SMS/email xác nhận. Nhân viên sẽ liên hệ trong vòng 24h để xác nhận đơn và lên lịch giao.</p>
    </StaticPage>
  )
}

export function ShippingPage() {
  const { data: s } = useSettings()
  return (
    <StaticPage
      title="Chính sách giao hàng"
      subtitle="Giao hàng toàn quốc, miễn phí đơn từ 5 triệu"
      icon={Truck}
    >
      <h2>1. Thời gian giao hàng</h2>
      <ul>
        <li>Nội thành TP.HCM, Hà Nội: <strong>24-48h</strong></li>
        <li>Các tỉnh miền Bắc, miền Trung: <strong>2-4 ngày</strong></li>
        <li>Các tỉnh miền Tây, Tây Nguyên: <strong>3-5 ngày</strong></li>
      </ul>
      <h2>2. Phí vận chuyển</h2>
      <ul>
        <li>Đơn từ <strong>{((s.freeShippingThreshold ?? 5000000) / 1000000).toFixed(0)} triệu</strong> trở lên: <strong>Miễn phí</strong></li>
        <li>Đơn dưới mức trên: {(s.defaultShippingFee ?? 50000).toLocaleString('vi-VN')}đ</li>
        <li>Đơn phụ kiện nhẹ: tính theo bảng giá vận chuyển</li>
      </ul>
      <h2>3. Lắp đặt & bàn giao</h2>
      <p>Với xe máy điện và xe đạp điện, kỹ thuật viên sẽ <strong>lắp đặt tận nơi</strong> và hướng dẫn sử dụng. Khách kiểm tra kỹ trước khi ký nhận.</p>
      <h2>4. Theo dõi đơn hàng</h2>
      <p>Đăng nhập vào mục <Link to="/don-hang">Đơn hàng của tôi</Link> để theo dõi trạng thái giao hàng realtime.</p>
    </StaticPage>
  )
}

export function FaqPage() {
  const items = [
    { q: 'Xe điện có cần đăng ký biển số không?', a: 'Xe máy điện có công suất trên 250W phải đăng ký biển số như xe máy. Xe đạp điện và xe máy điện dưới 250W không cần đăng ký.' },
    { q: 'Pin xe điện dùng được bao lâu?', a: 'Pin Lithium cao cấp dùng được 3-5 năm nếu bảo quản đúng cách, khoảng 800-1200 lần sạc.' },
    { q: 'Đi được bao nhiêu km mỗi lần sạc?', a: 'Tùy dòng xe, trung bình 60-80km với xe đạp điện và 80-120km với xe máy điện khi sạc đầy.' },
    { q: 'Thời gian sạc đầy pin bao lâu?', a: 'Khoảng 4-6 giờ tuỳ dung lượng pin. Nên sạc khi pin còn 20-30% để kéo dài tuổi thọ.' },
    { q: 'Có thể đi xe điện dưới trời mưa không?', a: 'Có, hầu hết xe đạt chuẩn IP54 chống nước. Tuy nhiên tránh ngập nước sâu quá trục bánh.' },
    { q: 'Xe có bảo hành cho người ngoài tỉnh không?', a: 'Có, Xe Điện Việt bảo hành toàn quốc. Khách có thể gửi xe về trung tâm bảo hành qua hệ thống vận chuyển, miễn phí trong năm đầu.' },
  ]
  return (
    <StaticPage title="Câu hỏi thường gặp" subtitle="Tổng hợp các thắc mắc phổ biến về xe điện và dịch vụ" icon={HelpCircle}>
      <div className="space-y-4 not-prose">
        {items.map((it, i) => (
          <details key={i} className="group border border-border rounded-lg p-4 open:bg-brand-50/50">
            <summary className="font-semibold text-text cursor-pointer list-none flex items-center justify-between gap-3">
              <span>{it.q}</span>
              <span className="w-6 h-6 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center text-sm shrink-0 group-open:rotate-45 transition">+</span>
            </summary>
            <p className="mt-3 text-sm text-muted leading-relaxed">{it.a}</p>
          </details>
        ))}
      </div>
    </StaticPage>
  )
}

export function AboutPage() {
  const { data: s } = useSettings()
  return (
    <StaticPage title="Giới thiệu" subtitle={`${s.shopName} — Di chuyển xanh, cuộc sống đẹp hơn`} icon={Users}>
      <p><strong>{s.shopName}</strong> là một trong những nhà phân phối xe điện hàng đầu Việt Nam, chuyên cung cấp xe máy điện, xe đạp điện và phụ kiện chính hãng từ các thương hiệu uy tín.</p>
      <h2>Tầm nhìn</h2>
      <p>Trở thành thương hiệu xe điện tin cậy #1 Việt Nam, góp phần xanh hoá giao thông đô thị và bảo vệ môi trường.</p>
      <h2>Sứ mệnh</h2>
      <ul>
        <li>Mang đến cho khách hàng sản phẩm chất lượng với giá cạnh tranh</li>
        <li>Dịch vụ sau bán hàng tận tâm — hỗ trợ trọn đời</li>
        <li>Đồng hành cùng xu hướng di chuyển xanh của Việt Nam</li>
      </ul>
      <h2>Thành tựu</h2>
      <ul>
        <li>Hơn <strong>50.000+ khách hàng</strong> tin tưởng mua xe</li>
        <li><strong>15 showroom</strong> trên toàn quốc</li>
        <li><strong>4.8/5 sao</strong> trên các nền tảng đánh giá</li>
      </ul>
    </StaticPage>
  )
}

export function StoresPage() {
  const stores = [
    { city: 'TP. Hồ Chí Minh', address: '123 Lê Lợi, Quận 1', phone: '0901 234 567', hours: '8:00 - 20:00' },
    { city: 'TP. Hồ Chí Minh', address: '456 Cộng Hoà, Tân Bình', phone: '0902 345 678', hours: '8:00 - 20:00' },
    { city: 'Hà Nội',          address: '12 Hoàng Quốc Việt, Cầu Giấy', phone: '0903 456 789', hours: '8:00 - 20:00' },
    { city: 'Hà Nội',          address: '88 Trần Duy Hưng, Cầu Giấy', phone: '0904 567 890', hours: '8:00 - 20:00' },
    { city: 'Đà Nẵng',         address: '45 Nguyễn Văn Linh, Hải Châu', phone: '0905 678 901', hours: '8:00 - 20:00' },
    { city: 'Cần Thơ',         address: '67 Mậu Thân, Ninh Kiều', phone: '0906 789 012', hours: '8:00 - 20:00' },
  ]
  return (
    <StaticPage title="Hệ thống cửa hàng" subtitle="15 showroom trên toàn quốc, phục vụ bạn gần nhất" icon={Building2}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 not-prose">
        {stores.map((s, i) => (
          <div key={i} className="border border-border rounded-lg p-5 hover:border-brand-500 hover:shadow-card transition">
            <div className="font-semibold text-text mb-1">{s.city}</div>
            <div className="text-sm text-muted space-y-1.5 mt-2">
              <div className="flex items-start gap-2"><MapPin className="w-4 h-4 text-brand-600 mt-0.5" /> {s.address}</div>
              <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-brand-600" /> <a href={`tel:${s.phone.replace(/\s/g, '')}`} className="hover:text-brand-600">{s.phone}</a></div>
              <div className="text-xs">⏰ {s.hours}</div>
            </div>
          </div>
        ))}
      </div>
    </StaticPage>
  )
}

export function CareersPage() {
  return (
    <StaticPage title="Tuyển dụng" subtitle="Gia nhập đội ngũ Xe Điện Việt — cùng thay đổi tương lai giao thông" icon={Briefcase}>
      <p>Chúng tôi luôn tìm kiếm những người đồng hành nhiệt huyết, chuyên nghiệp và yêu công nghệ xanh.</p>
      <h2>Vị trí đang tuyển</h2>
      <ul>
        <li><strong>Sales Showroom</strong> — Lương 10-20 triệu + hoa hồng — HCM, Hà Nội, Đà Nẵng</li>
        <li><strong>Kỹ thuật viên sửa chữa</strong> — Lương 12-18 triệu — Toàn quốc</li>
        <li><strong>Marketing Digital</strong> — Lương 15-25 triệu — HCM</li>
        <li><strong>Nhân viên kho</strong> — Lương 9-12 triệu — HCM, Hà Nội</li>
        <li><strong>Lái xe giao hàng</strong> — Lương 12-15 triệu — HCM, Hà Nội</li>
      </ul>
      <h2>Phúc lợi</h2>
      <ul>
        <li>Thưởng tháng 13, thưởng hiệu suất</li>
        <li>BHXH + BHYT đầy đủ</li>
        <li>Nghỉ phép 12 ngày/năm, du lịch công ty</li>
        <li>Môi trường trẻ, năng động</li>
      </ul>
      <p>Gửi CV về <a href="mailto:tuyendung@xediendviet.vn">tuyendung@xediendviet.vn</a> với tiêu đề <strong>[Vị trí] - Họ tên</strong>.</p>
    </StaticPage>
  )
}

export function TermsPage() {
  return (
    <StaticPage title="Điều khoản sử dụng" subtitle="Vui lòng đọc kỹ trước khi sử dụng dịch vụ của chúng tôi" icon={FileText}>
      <h2>1. Phạm vi áp dụng</h2>
      <p>Điều khoản này áp dụng cho mọi khách hàng truy cập website và mua sắm tại Xe Điện Việt.</p>
      <h2>2. Tài khoản khách hàng</h2>
      <p>Khách hàng tự chịu trách nhiệm bảo mật thông tin tài khoản. Xe Điện Việt không chịu trách nhiệm cho thiệt hại phát sinh từ việc để lộ mật khẩu.</p>
      <h2>3. Đặt hàng & thanh toán</h2>
      <ul>
        <li>Giá sản phẩm có thể thay đổi, giá cuối cùng là giá tại thời điểm xác nhận đơn</li>
        <li>Đơn hàng có thể bị huỷ nếu khách không nghe máy xác nhận sau 48h</li>
        <li>Thanh toán COD: khách kiểm tra kỹ trước khi nhận</li>
      </ul>
      <h2>4. Quyền sở hữu trí tuệ</h2>
      <p>Toàn bộ nội dung, hình ảnh, logo trên website thuộc quyền sở hữu của Xe Điện Việt. Nghiêm cấm sao chép, sử dụng cho mục đích thương mại mà không có sự đồng ý bằng văn bản.</p>
      <h2>5. Giải quyết tranh chấp</h2>
      <p>Mọi tranh chấp được giải quyết thông qua thương lượng. Trường hợp không thoả thuận được, toà án nhân dân có thẩm quyền sẽ thụ lý.</p>
    </StaticPage>
  )
}

export function PrivacyPage() {
  return (
    <StaticPage title="Chính sách bảo mật" subtitle="Thông tin của bạn — chúng tôi cam kết bảo vệ" icon={Lock}>
      <h2>1. Thu thập thông tin</h2>
      <p>Chúng tôi chỉ thu thập thông tin cần thiết cho việc xử lý đơn hàng: họ tên, SĐT, email, địa chỉ giao hàng.</p>
      <h2>2. Sử dụng thông tin</h2>
      <ul>
        <li>Xử lý đơn hàng và giao hàng</li>
        <li>Chăm sóc khách hàng, bảo hành</li>
        <li>Gửi ưu đãi (chỉ khi khách đồng ý)</li>
      </ul>
      <h2>3. Bảo mật thông tin</h2>
      <p>Mọi thông tin cá nhân được mã hoá và lưu trữ trên server đạt chuẩn bảo mật quốc tế. Không chia sẻ với bên thứ ba vì mục đích thương mại.</p>
      <h2>4. Quyền của khách hàng</h2>
      <ul>
        <li>Quyền truy cập, chỉnh sửa, xoá thông tin cá nhân</li>
        <li>Quyền từ chối nhận thông tin marketing</li>
        <li>Quyền khiếu nại về việc sử dụng dữ liệu</li>
      </ul>
      <p>Liên hệ <a href="mailto:privacy@xediendviet.vn">privacy@xediendviet.vn</a> để thực hiện các quyền trên.</p>
    </StaticPage>
  )
}

export function SitemapPage() {
  return (
    <StaticPage title="Sitemap" subtitle="Toàn bộ sơ đồ trang web" icon={Map}>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6 not-prose">
        <div>
          <div className="font-semibold text-text mb-2">Danh mục</div>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/" className="text-brand-600 hover:underline">Trang chủ</Link></li>
            <li><Link to="/danh-muc/xe-may-dien" className="text-brand-600 hover:underline">Xe máy điện</Link></li>
            <li><Link to="/danh-muc/xe-dap-dien" className="text-brand-600 hover:underline">Xe đạp điện</Link></li>
            <li><Link to="/danh-muc/phu-kien" className="text-brand-600 hover:underline">Phụ kiện</Link></li>
            <li><Link to="/khuyen-mai" className="text-brand-600 hover:underline">Khuyến mãi</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-text mb-2">Hỗ trợ</div>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/chinh-sach-bao-hanh" className="text-brand-600 hover:underline">Bảo hành</Link></li>
            <li><Link to="/chinh-sach-doi-tra" className="text-brand-600 hover:underline">Đổi trả</Link></li>
            <li><Link to="/chinh-sach-giao-hang" className="text-brand-600 hover:underline">Giao hàng</Link></li>
            <li><Link to="/huong-dan-mua-hang" className="text-brand-600 hover:underline">Hướng dẫn mua</Link></li>
            <li><Link to="/cau-hoi-thuong-gap" className="text-brand-600 hover:underline">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-text mb-2">Về chúng tôi</div>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/gioi-thieu" className="text-brand-600 hover:underline">Giới thiệu</Link></li>
            <li><Link to="/he-thong-cua-hang" className="text-brand-600 hover:underline">Hệ thống cửa hàng</Link></li>
            <li><Link to="/tuyen-dung" className="text-brand-600 hover:underline">Tuyển dụng</Link></li>
            <li><Link to="/tin-tuc" className="text-brand-600 hover:underline">Tin tức</Link></li>
            <li><Link to="/lien-he" className="text-brand-600 hover:underline">Liên hệ</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-text mb-2">Pháp lý</div>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/dieu-khoan" className="text-brand-600 hover:underline">Điều khoản sử dụng</Link></li>
            <li><Link to="/chinh-sach-bao-mat" className="text-brand-600 hover:underline">Chính sách bảo mật</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-text mb-2">Tài khoản</div>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/dang-nhap" className="text-brand-600 hover:underline">Đăng nhập</Link></li>
            <li><Link to="/dang-ky" className="text-brand-600 hover:underline">Đăng ký</Link></li>
            <li><Link to="/tai-khoan" className="text-brand-600 hover:underline">Tài khoản của tôi</Link></li>
            <li><Link to="/don-hang" className="text-brand-600 hover:underline">Đơn hàng</Link></li>
            <li><Link to="/gio-hang" className="text-brand-600 hover:underline">Giỏ hàng</Link></li>
          </ul>
        </div>
      </div>
    </StaticPage>
  )
}
